import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { STORAGE_APP } from './constants';
import { PreferencesService } from '../services/preferences.service';

export interface App {
  firstAccess: Date;
  lastConfirmationEmailRequest: Date | null;
  lastForceUpdateCheck: Date | null;
  lastAppUpdateBuildNumber: string; // Used in web only to fix the Failed to fetch dynamically imported module issue
  queryParams?: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class AppState {
  constructor(private preferenceService: PreferencesService) {}

  private readonly STORAGE_KEY = STORAGE_APP;

  appReady$ = new BehaviorSubject<boolean>(false);
  app$ = new BehaviorSubject<App>({
    firstAccess: new Date(),
    lastConfirmationEmailRequest: null,
    lastForceUpdateCheck: null,
    lastAppUpdateBuildNumber: '',
    queryParams: {},
  });
  stateReady$ = new BehaviorSubject<boolean>(false);

  async initialize(): Promise<void> {
    const storedApp = await this.get();
    storedApp ? this.app$.next(storedApp) : await this.set(this.app$.value);
  }

  private async get(): Promise<App | null> {
    return JSON.parse(<string>(await this.preferenceService.get(this.STORAGE_KEY)).value);
  }

  async set(settings: Partial<App>): Promise<void> {
    this.app$.next({ ...this.app$?.value, ...settings });
    await this.preferenceService.set(this.STORAGE_KEY, JSON.stringify(this.app$.value));
  }
}
